import { Router, Location } from '@reach/router'
import React from 'react'
import { BuildTransitionPath } from 'common-tools/index'
import { BaseRouter } from './BaseRouter'
import { motion, AnimatePresence } from 'framer-motion'

const duration = 0.5

const animateVariants = {
  y: 0,
  transition: {
    duration: duration
  }
}

const initialVariants = {
  y: '-100%'
}

const exitVariants = {
  y: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  transition: {
    duration: duration
  }
}

export class SlideDownRouter extends BaseRouter {
  constructor (props) {
    super(props)

    const { ignoreFirstMount } = props

    if (ignoreFirstMount === true) {
      this.firstMount = true
    } else {
      this.firstMount = false
    }
  }

  static defaultProps = {
    ignoreFirstMount: true
  }

  firstMount = true

  render () {
    const { children, area, uri, maxSegments, ignoreParent, primary } = this.props
    const { hasError } = this.state

    if (hasError) {
      return this.renderError()
    }

    let initSetting = initialVariants
    if (this.firstMount === true) {
      initSetting = false
      this.firstMount = false
    }

    return <Location>
      {({ location }) => {
        // console.log(location.key, location)
        let key = BuildTransitionPath(uri || '', location.pathname, uri || area || '', maxSegments || 1)
        return <AnimatePresence key='slidedown'><motion.div inherit={!ignoreParent} style={{ height: '100%' }} key={key}
          initial={initSetting}
          animate={animateVariants}
          exit={exitVariants}
        >
          <Router location={location} style={{ height: '100%', width: '100vw' }} uri={uri || ''} primary={primary === true}>{children}</Router>
        </motion.div>
        </AnimatePresence>
      }}
    </Location>
  }
}
